import { moment } from "#src/utils/dateTime.ts";
import { TimeType } from "#types/code-generator.ts";

interface CheckOrganizationPaymentAlertsInput {
  organization: {
    chargeStartDate: Date;
    chargeAnnualStartDate?: Date;
    lastFailedPayment: Date;
    owner: {
      adyenToken?: any;
      stripeCustomerId: string;
      stripeToken: any;
      balance: number;
    };
    gracePeriod: number;
    gracePeriodType: TimeType;
  };
}

export function checkOrganizationPaymentAlerts(
  args: CheckOrganizationPaymentAlertsInput
) {
  const today = moment();
  const isCharging =
    args.organization.chargeStartDate ||
    args.organization.chargeAnnualStartDate;
  const hasBalanceAlert = args.organization.owner?.balance > 0;
  let balanceDeadline =
    args.organization.lastFailedPayment &&
    args.organization.gracePeriod &&
    moment(args.organization.lastFailedPayment);

  // console.log("balanceDeadline", balanceDeadline);

  if (isCharging && hasBalanceAlert && args.organization.gracePeriod) {
    if (balanceDeadline) {
      balanceDeadline = balanceDeadline.add(
        args.organization.gracePeriod,
        args.organization
          .gracePeriodType as moment.unitOfTime.DurationConstructor
      );
    }
  }

  // console.log("paymentMethodDeadline", paymentMethodDeadline?.format());
  // console.log("balanceDeadline", balanceDeadline?.format());

  const isSuspended =
    hasBalanceAlert &&
    balanceDeadline &&
    balanceDeadline.isBefore(today, "day");

  return {
    hasBalanceAlert,
    isSuspended,
    balanceDeadline,
  };
}
